import { render, staticRenderFns } from "./AddPartner.vue?vue&type=template&id=523a080a&scoped=true&"
import script from "./AddPartner.vue?vue&type=script&lang=js&"
export * from "./AddPartner.vue?vue&type=script&lang=js&"
import style0 from "./AddPartner.vue?vue&type=style&index=0&id=523a080a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523a080a",
  null
  
)

export default component.exports